import { render, staticRenderFns } from "./SupportBar.vue?vue&type=template&id=3a9cd574&scoped=true"
import script from "./SupportBar.vue?vue&type=script&lang=js"
export * from "./SupportBar.vue?vue&type=script&lang=js"
import style0 from "./SupportBar.vue?vue&type=style&index=0&id=3a9cd574&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9cd574",
  null
  
)

export default component.exports